<template>
    <base-dashboard-view class="integrations">
        <header class="integrations-header">
            <h2 class="title">
                {{ siteTitle }}
            </h2>
            <base-search-input
                placeholder="Search platform..."
                @input="value => searchPhrase = value"
            />
            <p class="description">
                Click on your platform for instructions on how to embed your Fusebox Player
            </p>
        </header>

        <div
            class="integrations-container"
        >
            <integration
                v-for="integration in filtredIntegrations"
                :key="integration.name"
                :integration="integration"
            />
            <div
                class="last-box box integration"
                @click="openBeacon"
            >
                <p class="title">
                    Don't see your platform?
                </p>
                <p class="description">
                    <a href="#">Contact us</a> for help.
                </p>
            </div>
        </div>
    </base-dashboard-view>
</template>

<script>
import dashboardTitle from '@/mixins/dashboardTitle';
import Integration from '@/components/Integrations/Integration';
import integrationsConfig from '@/utils/config/integrations';
import { phraseFilter } from '@/utils/listFilters';

const integrations = integrationsConfig.integrationsArray;

export default {
    components: {
        Integration,
    },
    mixins: [dashboardTitle],

    data: () => ({
        integrations,
        searchPhrase: '',
        showModal: false,
    }),

    computed: {
        /**
         * @returns {Array} Filtered integrations
         *
         */
        filtredIntegrations() {
            return ('' !== this.searchPhrase)
                ? phraseFilter(this.integrations, 'name', this.searchPhrase)
                : this.integrations;
        },
    },

    methods: {
        /**
         * Open beacon
         *
         */
        openBeacon() {
            window.Beacon('open');
        },
    },
};
</script>
